export var dateFormatter = function (locale, numericDateEnabled) { return function (date) {
    return localDate(date).toLocaleDateString(locale, {
        month: numericDateEnabled ? 'numeric' : 'short',
        year: 'numeric',
        day: 'numeric',
    });
}; };
export var hourFormatter = function (locale) { return function (date) {
    return new Date(date).toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: 'numeric',
    });
}; };
var isUtcBeforeFix = function (utcDate) {
    return utcDate.getUTCHours() !== 0 ||
        utcDate.getUTCMinutes() !== 0 ||
        utcDate.getUTCSeconds() !== 0;
};
export var localDate = function (date) {
    var dateAsDate = new Date(date);
    return isUtcBeforeFix(dateAsDate)
        ? dateAsDate
        : new Date(dateAsDate.getUTCFullYear(), dateAsDate.getUTCMonth(), dateAsDate.getUTCDate(), dateAsDate.getUTCHours(), dateAsDate.getUTCMinutes());
};
export var toStartOfDayUTC = function (date) {
    if (typeof date === 'string') {
        return new Date(date.split('T')[0] + 'T00:00:00.000Z');
    }
    return new Date(date.toISOString().split('T')[0] + 'T00:00:00.000Z');
};
//# sourceMappingURL=index.js.map